import { isAndroid } from '@helpers';
import { NCParsedLine, NCToken, NCTokenType, ParseNCFileContentOptions } from '@components/common/NCFile/types';

const systemReplace = (s: string): string => (isAndroid ? String(s).replace(/\x00/g, '') : s.replace(/\u0000/g, ''));

export const parseNCFileContent = (data: string, options: ParseNCFileContentOptions): NCParsedLine[] => {
  const { withCollapsing } = options;
  const rawLines = data.split('\n');
  const result: NCParsedLine[] = [];

  let lineIndex = 0;
  let currentToolSectionIndex = -1;
  let insideToolSection = false;

  for (let i = 0; i < rawLines.length; i++) {
    if (rawLines[i].replace('\0', '').trim().length === 0) {
      continue;
    }

    const line = rawLines[i];
    const parts = line.split(' ');
    const tokens: NCToken[] = [];
    let isCommentStarted = false;

    parts.forEach((p) => {
      if (p === '') {
        return;
      }

      const pFormatted = systemReplace(p);

      if (isCommentStarted || pFormatted.indexOf(';') > -1) {
        isCommentStarted = true;
        tokens.push({ value: p, type: NCTokenType.COMMENT });
        return;
      }

      if (pFormatted.indexOf('FMAX') > -1) {
        tokens.push({ value: p, type: NCTokenType.FMAX });
        return;
      }

      if (Number(pFormatted) === lineIndex) {
        tokens.push({ value: p, type: NCTokenType.LINE_NUMBER });
        lineIndex += 1;
        return;
      }

      const isNumber = Number(pFormatted);

      if (!isNaN(isNumber)) {
        tokens.push({ value: p, type: NCTokenType.VALUE });
        return;
      }

      const letters = ['X', 'Y', 'Z'];
      const exist = letters.includes(pFormatted[0]);
      const numberPart = pFormatted.slice(1, p.length);
      const number = Number(numberPart);

      if (exist && numberPart && (number || number === 0)) {
        tokens.push({ value: pFormatted[0], type: NCTokenType.DEFAULT, noTrailingSpace: true });
        tokens.push({ value: number > 0 ? `+${number}` : `${number}`, type: NCTokenType.VALUE });
        return;
      }

      tokens.push({ value: p, type: NCTokenType.DEFAULT });
    });

    const toolCallIndex = line.indexOf('TOOL CALL');
    const commentIndex = line.indexOf(';');
    const isToolCall = withCollapsing && toolCallIndex > -1 && (commentIndex === -1 || commentIndex > toolCallIndex);

    if (isToolCall) {
      currentToolSectionIndex++;
      insideToolSection = true;
    }

    result.push({
      key: `nc-line-${i}`,
      tokens,
      isToolCall,
      toolSectionIndex: insideToolSection ? currentToolSectionIndex : null,
      rawText: line,
    });
  }

  return result;
};
